var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquarerPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.66 0.000244141C18.06 0.000244141 20 1.92024 20 5.33024V14.6702C20 18.0602 18.07 20.0002 14.67 20.0002H5.33C1.92 20.0002 0 18.0602 0 14.6702V5.33024C0 1.92024 1.92 0.000244141 5.33 0.000244141H14.66ZM9.99 5.51024C9.53 5.51024 9.16 5.88024 9.16 6.34024V9.16024H6.33C6.11 9.16024 5.9 9.25024 5.74 9.40024C5.59 9.56024 5.5 9.76924 5.5 9.99024C5.5 10.4502 5.87 10.8202 6.33 10.8302H9.16V13.6602C9.16 14.1202 9.53 14.4902 9.99 14.4902C10.45 14.4902 10.82 14.1202 10.82 13.6602V10.8302H13.66C14.12 10.8202 14.49 10.4502 14.49 9.99024C14.49 9.53024 14.12 9.16024 13.66 9.16024H10.82V6.34024C10.82 5.88024 10.45 5.51024 9.99 5.51024Z",
    fill: "#605BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarerPurple);
export default __webpack_public_path__ + "static/media/squarer-purple.56144dab40778d98dfa11705eedd13ad.svg";
export { ForwardRef as ReactComponent };